import React from 'react';
import {
  CalendarIcon,
  ClipboardDocumentListIcon,
  Cog6ToothIcon,
  FolderIcon,
  ListBulletIcon,
  NewspaperIcon,
  PresentationChartLineIcon,
  UsersIcon,
  AcademicCapIcon,
  BuildingOffice2Icon,
  GlobeAltIcon, GlobeAmericasIcon, BookOpenIcon,
  RocketLaunchIcon
} from '@heroicons/react/24/outline';
import { useUser } from '@lore/auth';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

export default function useMainNavigationLinks() {
  const currentUser = useUser();
  const { t } = useTranslation();

  const urls = {
    workspace: `/workspace/sales`,
    dashboard: `/dashboard`,
    feed: `/feed`,
    sites: `/sites`,
    pastProjects: '/past-projects',
    manage: `/manage`,
    // stewards: `/stewards`,
    projects: `/projects`,
    events: `/events`,
    offers: `/offers`,
    partners: `/partners`,
    educators: `/educators`,
    evaluations: `/evaluations`,
    settings: `/settings`,
    states: `/states`,
    // team lives under settings
    team: `/team`
  };

  // return the navigation list but use compact to remove "staff-only" links if this user is not staff
  return _.compact([
    currentUser.data.isStaff ? { name: t('Workspace', {count: 2}), icon: RocketLaunchIcon, to: urls.workspace, startsWithOneOf: ['/workspace'], id: 'workspaces' } : null,
    { name: 'Dashboard', icon: PresentationChartLineIcon, to: urls.dashboard },
    { name: 'Feed', icon: ListBulletIcon, to: urls.feed },
    currentUser.data.isStaff ?
      { name: 'Sites', icon: BuildingOffice2Icon, to: urls.sites, secret: true } :
      null,
    currentUser.data.isStaff ?
      { name: 'Past Projects', icon: BookOpenIcon, to: urls.pastProjects, secret: true } :
      null,
    { name: 'Projects', icon: FolderIcon, to: urls.projects },
    { name: 'Events', icon: CalendarIcon, to: urls.events },
    { name: 'Offers', icon: NewspaperIcon, to: urls.offers },
    { name: 'Partners', icon: UsersIcon, to: urls.partners },
    { name: 'Educators', icon: AcademicCapIcon, to: urls.educators },
    { name: 'Evaluations', icon: ClipboardDocumentListIcon, to: urls.evaluations },
    { name: 'Settings', icon: Cog6ToothIcon, to: urls.settings, startsWithOneOf: [urls.settings, urls.team] },
    currentUser.data.isStaff ?
      { name: '[States]', icon: GlobeAmericasIcon, to: urls.states, startsWithOneOf: [urls.states], secret: true } :
      null,
    currentUser.data.isStaff ?
      { name: '[Manage networks]', icon: GlobeAltIcon, to: urls.manage, startsWithOneOf: [urls.manage], secret: true } :
      null
  ]);
}
